import { Box, Spinner } from "@chakra-ui/react"

/** Default blocks loading UI when consumer does not provide renderLoading. Simple centered spinner. */
export const DefaultLoading = () => (
  <Box
    minH="300px"
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <Spinner size="lg" color="gray.600" />
  </Box>
)
